import { Component, OnInit, Output, EventEmitter, ViewChild, ElementRef, Input } from '@angular/core';

@Component({
  selector: 'app-file-drag-drop',
  templateUrl: './file-drag-drop.component.html',
  styleUrls: ['./file-drag-drop.component.scss']
})
export class FileDragDropComponent implements OnInit {

  public file: any;
  public isDragged = false;

  @Input() uplaodImg;
  @Input() message;
  @Input() fileName;
  @Input() browseLabel;
  @Input() showOnUploadAttempt;
  @Input() isSuccess;
  @Output() fileSelectedCallback = new EventEmitter();
  @Output() openModalCallback = new EventEmitter();
  @ViewChild('fileUpload', { static: true }) inputVar: ElementRef;
  constructor() { }

  ngOnInit() {
  }

  onDragOver(event): void {
    event.preventDefault();
    this.isDragged = true;
  }

  onDragLeave(event): void {
    this.isDragged = false;
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    this.isDragged = false;
    if (event.dataTransfer.items) {
      // Use DataTransferItemList interface to access the file
      if (event.dataTransfer.items[0] && event.dataTransfer.items[0].kind === 'file' &&
          event.dataTransfer.items[0].type === 'application/vnd.ms-excel') {
        const file = event.dataTransfer.items[0].getAsFile();
        this.file = file;
        if (this.fileSelectedCallback) {
          this.fileSelectedCallback.emit(this.file);
        }
      }
    }
  }

  onFileSelected(event: any) {
    const file = event.target.files[0];
    this.file = file;
    if (this.fileSelectedCallback) {
      this.fileSelectedCallback.emit(this.file);
    }
    this.inputVar.nativeElement.value = '';
  }

  openModal() {
    this.openModalCallback.emit(this.isSuccess);
  }
}
